import { render, staticRenderFns } from "./LimitTab.vue?vue&type=template&id=995d5d68&scoped=true"
import script from "./limit-tab.js?vue&type=script&lang=js&external"
export * from "./limit-tab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995d5d68",
  null
  
)

export default component.exports